import React from 'react';
const projectImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/vQM6w8FSiBR3ZoYjoaBXdA/Ca_1.webp',
  alt: 'Proyecto Neon Flex 1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6WFspb1P6rKRNS86i2Sswm/ca_2.webp',
  alt: 'Proyecto Neon Flex 2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cDycxP6HJWvsZH8HtAVifr/ca_3.webp',
  alt: 'Proyecto Neon Flex 3'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bL5Mo2ofSrV3PoiX5cQHwr/ca_4.webp',
  alt: 'Proyecto Neon Flex 4'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2xWWQDmhkFTxsCRbznHiZ1/ca_5.webp',
  alt: 'Proyecto Neon Flex 5'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nPiPTX7X49ahAmHNJdd3JW/ca_6.webp',
  alt: 'Proyecto Neon Flex 6'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jTzxxtrtUb6HgfRF6cqbL4/ca_7.webp',
  alt: 'Proyecto Neon Flex 7'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nCjX6GncDjVAkATXmFQGs7/ca_8.webp',
  alt: 'Proyecto Neon Flex 8'
}];
export function ProjectCarousel() {
  return <section className="relative z-10 overflow-hidden border-y border-white/5 bg-transparent py-10" data-id="element-185" data-mp="1m5jkwn1h9ieb">
      <div className="mx-auto mb-8 max-w-7xl px-4 text-center" data-id="element-186" data-mp="20ug0r69rzzph">
        <h2 className="mb-4 text-4xl font-black tracking-tight text-white md:text-6xl" data-id="element-187" data-mp="20to5jwk3c3zq">
          PROYECTOS QUE <span className="text-[#00f0ff]" data-id="element-188" data-mp="1vw4qwvjhdp79">VAS A LOGRAR</span>
        </h2>
        <p className="mx-auto max-w-2xl text-xl font-medium text-gray-400" data-id="element-189" data-mp="186jx1hlsh7j7">
          Desde carteles comerciales hasta piezas de decoración únicas. El
          límite es tu imaginación.
        </p>
      </div>

      <div className="flex snap-x snap-mandatory gap-5 overflow-x-auto px-4 pb-5 pt-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Galería de proyectos realizados con Neon Flex" data-id="element-190" data-mp="1i5j6v3iaj97s">
        {projectImages.map((image, index) => <figure key={image.src} className="group relative h-[200px] w-[300px] shrink-0 snap-center overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl md:h-[320px] md:w-[450px]" data-id="element-191" data-mp="2oktowlp8pees" data-mpi={index}>
            <img src={image.src} alt={image.alt} width={450} height={320} loading={index < 2 ? 'eager' : 'lazy'} decoding="async" className="h-full w-full object-cover transition-transform duration-500 motion-reduce:transition-none md:group-hover:scale-105" data-id="element-192" data-mp="30kgsbvsaxsw0" />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#1a0b2e]/70 via-transparent to-transparent" data-id="element-193" data-mp="2hwvcqmrw1sjo" />
          </figure>)}
      </div>
    </section>;
}